import { useState } from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper } from '@fortawesome/pro-duotone-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './DashboardNewsItem.scss';
import dayjs from 'dayjs';
import DashboardNewsDialog from '../DashboardNewsDialog';
import { NewsDTO } from '@bludata/fc-aggregator';
import DOMPurify from 'dompurify';

interface Props {
  news: NewsDTO;
  icon?: IconDefinition;
}

function DashboardNewsItem(props: Props) {
  const [showDialogNews, setShowDialogNews] = useState('');
  const { news, icon = faNewspaper } = props;
  const date = dayjs(news.date).format('dddd DD MMMM YYYY');

  const onClickInterceptor = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'A') {
      e.preventDefault();

      const url = new URL((target as HTMLAnchorElement).href);

      if (url.hostname.indexOf('.bludata.com') !== -1) {
        setShowDialogNews((target as HTMLAnchorElement).href);
      } else {
        window.open((target as HTMLAnchorElement).href, '_blank');
      }
    }
  };

  return (
    <Paper
      variant="outlined"
      className="dashboard-news-list-item"
      onClick={onClickInterceptor}
    >
      {!!showDialogNews && (
        <DashboardNewsDialog
          onClose={() => setShowDialogNews('')}
          newsUrl={showDialogNews}
        />
      )}
      <Stack flex={1} flexDirection="column" spacing={2}>
        <Stack flexDirection="row" alignItems="center" gap={2}>
          <FontAwesomeIcon className="news-icon" icon={icon} />
          <Typography className="news-date">{date}</Typography>
        </Stack>
        <Typography className="news-title" component="div">
          <div
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(news.title) }}
          />
        </Typography>
        <Typography className="news-content" component="div">
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(news.content),
            }}
          />
        </Typography>
      </Stack>
    </Paper>
  );
}

export default DashboardNewsItem;
